import { render, staticRenderFns } from "./UserModal.vue?vue&type=template&id=c4d76d1a&scoped=true"
import script from "./UserModal.vue?vue&type=script&lang=ts"
export * from "./UserModal.vue?vue&type=script&lang=ts"
import style0 from "./UserModal.vue?vue&type=style&index=0&id=c4d76d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d76d1a",
  null
  
)

export default component.exports